module.exports = __webpack_public_path__ + "static/media/erik-on.387a434d.png";